import React from 'react';
import { Users, CheckCircle, Clock } from 'lucide-react';
import { Layout } from '../components/Layout';
import { StatCard } from '../components/StatCard';
import { LeadQueue } from '../components/LeadQueue';
export function FollowUpQueue() {
  return <Layout data-id="element-275">
      <div className="max-w-7xl mx-auto space-y-8" data-id="element-276">
        <div data-id="element-277">
          <h1 className="text-2xl font-bold text-slate-900" data-id="element-278">Follow-up Queue</h1>
          <p className="text-slate-500 mt-1" data-id="element-279">
            Manage your daily lead communications and campaign follow-ups.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-280">
          <StatCard title="Total Follow-ups Today" value={12} icon={<Users size={20} data-id="element-282" />} trend={{
          value: '2 from yesterday',
          isPositive: true
        }} data-id="element-281" />
          <StatCard title="Completed" value={4} icon={<CheckCircle size={20} data-id="element-284" />} className="border-emerald-100 bg-emerald-50/30" data-id="element-283" />
          <StatCard title="Pending" value={8} icon={<Clock size={20} data-id="element-286" />} className="border-amber-100 bg-amber-50/30" data-id="element-285" />
        </div>

        <LeadQueue data-id="element-287" />
      </div>
    </Layout>;
}